<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.name" style="width: 120px;" size="mini"
                        placeholder="名称" clearable></el-input>
                    <el-input v-model="formDatas.bizCode" style="width: 120px;" size="mini"
                        placeholder="编码" clearable></el-input>
                    <el-select size="mini" v-model="formDatas.syncStatusJindie" clearable @change="partserch" placeholder="同步金蝶状态"
                       style="width: 130px">
                       <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                   
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fmrId"
                        :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { getFxxkMeikeSupplierList,syncFxxkMeikeSupplierToJindie } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            IsDetail: false,
            DetailArr: '',
            key: 'fmrId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "bizCode",
                    key: "bizCode",
                    title: "编码",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 150,
                },
                {
                    field: "name",
                    key: "name",
                    title: "名称",
                    align: "center",
                    edit: false,
                    width: 170,
                },
                {
                    field: "enabled",
                    key: "enabled",
                    title: "是否启用",
                    align: "center",
                    edit: false,
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.enabled+'';
                    },
                },
                {
                    field: "idJindie",
                    key: "idJindie",
                    title: "对应金蝶id",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "partnerType",
                    key: "partnerType",
                    title: "往来单位关系",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "partnerProperty",
                    key: "partnerProperty",
                    title: "往来单位性质",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "accounts",
                    key: "accounts",
                    title: "账户信息",
                    align: "center",
                    edit: false,
                    width: 150,
                    ellipsis: {
                        showTitle: true,
                        lineClamp: 2,
                    },
                },
                {
                    field: "reMarks",
                    key: "reMarks",
                    title: "往来单位备注",
                    align: "center",
                    edit: false,
                    width: 100,
                },
                {
                    field: "taxNumber",
                    key: "taxNumber",
                    title: "税务登记号",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "syncStatusJindie",
                    key: "syncStatusJindie",
                    title: "同步金蝶",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "syncStatusJindieMsg",
                    key: "syncStatusJindieMsg",
                    title: "同步信息",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 120,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (  <span>
                                {
                                    row ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handlRest(row)}
                                    >
                                        重新同步
                                    </el-button> : ''
                                }
                                 </span>
                                );
                    },
                }, 
              
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                bizCode:"",
                name:"",
                syncStatusJindie:'',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        handlRest(row){
            this.$confirm('确定要重新同步吗？', '提示', {
                confirmButtonText: '确定',
                 cancelButtonText: '取消',
                 type: 'warning'
            }).then(() => {
                this.openLoading();
                syncFxxkMeikeSupplierToJindie({fmsId:row.fmsId}).then((res) => {
                    this.loadings.close();
                    if(res.data){
                         this.$message({
                            type: 'error',
                            message: res.data
                        });
                    }else{
                         this.$message({
                            type: 'success',
                            message: '同步成功'
                        });
                        this.getList();
                    }
                }).catch(() => {
                    this.loadings.close();
                });

            }).catch(() => {
            });
        },
                 
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleDetail(row) {
            getFxxkItineraryDingtalkDetails({ fmrId: row.fmrId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkMeikeSupplierList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkMeikeSupplierList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkMeikeSupplierList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>